import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout } from "antd";
import ModuleBar from "./ModuleBar";
import Footer from "./Footer";
import { LoadingProvider } from "../../store/context/loading-context"
import { AxiosInterceptor } from "./AxiosInterceptor";
import ModalFirstPassword from "../modal/user/ModalFirstPassword";
// import { useSelector } from "react-redux";
import { waitingApproved } from '../../store/slices/sample-preparation-approve.slices';
import { useAppDispatch } from '../../store/store';

const { Content } = Layout;

function Main({ children }) {
  // const waitingApproveReducer = useSelector(waitingApprovedSliceSelector); 
  const dispatch = useAppDispatch();



  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    dispatch(waitingApproved());
  }, [dispatch, pathname]);

  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Layout>
        <LoadingProvider>
          <ModuleBar />

          <AxiosInterceptor>
            <Content className="content-ant" style={{"overflow":"hidden", "position":"relative"}}>
              {children}
            </Content>              
          </AxiosInterceptor>

          {/* ผู้ใช้ใหม่ที่เพิ่งเข้าระบบครั้งแรก ต้องตั้งรหัสผ่านก่อนใช้งาน */}
          <ModalFirstPassword />

        <Footer />
        </LoadingProvider>
      </Layout>
    </Layout>
  );
}

export default Main;
